import BasicStyles from './BasicDetails.module.scss';
import EduStyles from './EducationDetails.module.scss';
import Styles from './WorkDetails.module.scss';
import TextField from '@mui/material/TextField';
import Slide from '@mui/material/Slide';

export function WorkDetails({
    experience,
    setExperience,
    expValidation,
    setExpValidation,
    props
}) {
    let expData = {
        company_name: null,
        company_position: null,
        company_start_year: null,
        company_end_year: null,
        company_accomp: null,
    }

    const handleAddWork = () => {
        setExperience([
            ...experience,
            expData
        ]);
        setExpValidation([
            ...expValidation,
            Object.fromEntries(Object.entries(expData).map(([key]) => [key, true]))
        ])
    }

    const handleDeleteItem = (index) => {
        const updatedItems = experience.filter((_, i) => i !== index);
        const updatedValidation = experience.filter((_, i) => i !== index);
        setExperience([...updatedItems]);
        setExpValidation([...updatedValidation]);
    };

    const handleWorkInputChange = (inputValue, field, index) => {
        let isValid = true;
        const currentYear = new Date().getFullYear()
        switch (field) {
            case 'company_start_year':
                if (parseInt(inputValue) <= 1970 || parseInt(inputValue) > currentYear + 2) {
                    isValid = false;
                    break;
                }
                isValid = /^\d{4}$/.test(parseInt(inputValue));
                break;
            case 'company_end_year':
                if (parseInt(inputValue) <= 1970 || parseInt(inputValue) > currentYear + 2) {
                    isValid = false;
                    break;
                }
                isValid = (/^\d{4}$/.test(parseInt(inputValue)) || inputValue.toLowerCase() === 'ongoing');
                break;
            default:
                isValid = inputValue.trim() !== '';
                break;
        }

        setExpValidation(prevValidation => {
            const updatedValidation = [...prevValidation];
            updatedValidation[index][field] = isValid;
            return updatedValidation;
        });

        setExperience(prevExperience => {
            const updatedExperience = [...prevExperience];
            updatedExperience[index][field] = inputValue;
            return updatedExperience;
        });
    }

    return (
        <>
            <Slide direction="left" in mountOnEnter unmountOnExit>
                <div id='eduFormContainer'
                    style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <div id='workForm' className={`${BasicStyles.nameForm} ${Styles.workForm}`}>
                        {experience.length ? (
                            <>
                                <p
                                    id='subHeading'
                                    className={`${BasicStyles.subHeading}`}
                                >
                                    Experience
                                </p>
                                <div
                                    id='workBoxes'
                                    className={`${BasicStyles.nameTextboxes} ${EduStyles.educationForm}`}
                                >
                                    {experience.map((expRec, index) => (
                                        <span key={`${index}-experience`} className={Styles.expComponent}>
                                            <div key={index} >
                                                <button onClick={() => handleDeleteItem(index)}>❌</button>
                                            </div>
                                            <div key={`${index}-expComponent`} style={{ width: '93%' }}>
                                                <div key={`${index}-experience`} id='pgInputs' className={EduStyles.pgInputs}>
                                                    <TextField
                                                        error={!expValidation[index].company_name}
                                                        id={`${index}-company-name`}
                                                        label="Company Name"
                                                        placeholder="Company Name, Location"
                                                        fullWidth={false}
                                                        helperText={!expValidation[index].company_name ? 'Enter Your Company Name' : ' '}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        InputProps={{
                                                            maxLength: 50
                                                        }}
                                                        value={expRec.company_name || ''}
                                                        onChange={(e) => handleWorkInputChange(e.target.value, 'company_name', index)}
                                                    />

                                                    <TextField
                                                        error={!expValidation[index].company_position}
                                                        id={`${index}-company-position`}
                                                        label="Company Position"
                                                        placeholder="Company Position"
                                                        fullWidth={false}
                                                        helperText={!expValidation[index].company_position ? 'Enter Your Company Position' : ' '}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        InputProps={{
                                                            maxLength: 50
                                                        }}
                                                        value={expRec.company_position || ''}
                                                        onChange={(e) => handleWorkInputChange(e.target.value, 'company_position', index)}
                                                    />

                                                    <TextField
                                                        error={!expValidation[index].company_start_year}
                                                        id={`${index}-company-start-year`}
                                                        label="Start Year"
                                                        placeholder="YYYY"
                                                        fullWidth={false}
                                                        helperText={!expValidation[index].company_start_year ? 'Enter Your Company Start Year' : ' '}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        InputProps={{
                                                            maxLength: 4
                                                        }}
                                                        value={expRec.company_start_year || ''}
                                                        onChange={(e) => handleWorkInputChange(e.target.value, 'company_start_year', index)}
                                                    />

                                                    <TextField
                                                        error={!expValidation[index].company_end_year}
                                                        id={`${index}-company-end-year`}
                                                        label="End Year"
                                                        placeholder="YYYY / Ongoing"
                                                        fullWidth={false}
                                                        helperText={!expValidation[index].company_end_year ? 'Enter Your Company End Year' : ' '}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        InputProps={{
                                                            maxLength: 7
                                                        }}
                                                        value={expRec.company_end_year || ''}
                                                        onChange={(e) => handleWorkInputChange(e.target.value, 'company_end_year', index)}
                                                    />
                                                </div>
                                                {index <= 1 &&
                                                    <div>
                                                        <TextField
                                                            error={!expValidation[index].company_accomp}
                                                            id={`${index}-company-accomp`}
                                                            label="Top 3 Accomplishments"
                                                            placeholder="Eg: Reduced Production Defects by 15% using XYZ Methods. Increased productivity."
                                                            fullWidth={true}
                                                            helperText={!expValidation[index].company_accomp ? 'Enter Your Company Accomplishments' : ' '}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            InputProps={{
                                                                maxLength: 150
                                                            }}
                                                            rows={3}
                                                            multiline={true}
                                                            value={expRec.company_accomp || ''}
                                                            onChange={(e) => handleWorkInputChange(e.target.value, 'company_accomp', index)}
                                                        />
                                                    </div>
                                                }
                                                {
                                                    (experience.length > 1 && experience.length - 1 !== index) &&
                                                    <div key={`${index}-sep`} id='separator' className={Styles.separator} />
                                                }
                                            </div>
                                        </span>
                                    ))}
                                </div>

                            </>
                        ) : (
                            <>
                                If you are a fresher, please skip filling this and click on Next.
                            </>
                        )
                        }
                    </div>
                    <div id='workBtnCOntainer' className={EduStyles.eduBtnContainer}>
                        <button
                            onClick={handleAddWork}
                            id='addExpBtn' className={EduStyles.addPGBtn}
                        >
                            Add Experience
                        </button>
                    </div>
                </div>
            </Slide>
        </>
    )
}